import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { Begaran } from '../models/begaran.model';

/**
 * This class has to be extended and overriden
 * on the application using formrenderer library.
 */
@Injectable({
  providedIn: 'root',
})
export class BaseBegaranService {
  begaran = new BehaviorSubject<Begaran>(undefined);
  public begaran$ = this.begaran.asObservable();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public getBegaran(begaranId: string): Observable<Begaran> {
    return of(undefined);
  }
}
